import { render, staticRenderFns } from "./SimpleVScroll.vue?vue&type=template&id=7098dfdd&scoped=true"
import script from "./SimpleVScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleVScroll.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SimpleVScroll.vue?vue&type=style&index=0&id=7098dfdd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7098dfdd",
  null
  
)

export default component.exports